import { A11y, Autoplay, default as Swiper, default as SwiperCore, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, Keyboard, Mousewheel, Navigation, Pagination, Parallax, SwiperOptions } from 'swiper';
import 'swiper/css/bundle';
import { KeyboardOptions } from 'swiper/types/modules/keyboard';
import { NavigationOptions } from 'swiper/types/modules/navigation';
import { PaginationOptions } from 'swiper/types/modules/pagination';
import { mergeOptions } from '../../helpers/common/merge-options';

SwiperCore.use([Navigation, Pagination, A11y, EffectCreative, EffectCards, EffectCoverflow, EffectCube, EffectFade, EffectFlip, Mousewheel, Keyboard, Autoplay, Parallax]);

export enum PaginationTypes {
	bullets = "bullets",
	fraction = "fraction",
	progressbar = "progressbar",
	custom = "custom",
}

export interface CustomSwiperOptions {
	slidesPerView: number,
	initialSlide: number,
	breakpoints: SwiperOptions['breakpoints'],
	vertical: boolean,
	loop: boolean,
	centeredSlides: boolean,
	scale: boolean,
	spacing: number,
	autoplay: number | boolean,
	pagination?: PaginationOptions,
	effect: string,
	events?: any,
	mousewheel: boolean,
	mousewheelTarget?: string,
	keyboard: boolean | KeyboardOptions,
	navigation: NavigationOptions,
	preventClicks: boolean;
}

export class SwiperItem {
	static options: CustomSwiperOptions = {
		slidesPerView: 1,
		initialSlide: 0,
		vertical: false,
		autoplay: false,
		loop: false,
		breakpoints: undefined,
		centeredSlides: false,
		scale: false,
		spacing: 0,
		events: undefined,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: PaginationTypes.bullets,
		},
		effect: 'cards',
		keyboard: true,
		mousewheel: true,
		mousewheelTarget: 'container',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		preventClicks: true
	};
	private options: CustomSwiperOptions;
	private swiper: any;

	constructor(element: HTMLElement, options?: Partial<CustomSwiperOptions>) {
		this.options = mergeOptions(SwiperItem, options, element);

		if (typeof this.options.pagination?.el == 'string') {
			this.options.pagination.el = element.querySelector<HTMLElement>(this.options.pagination.el)
		}

		this.initSwiper(element);
	}

	private initSwiper(element: HTMLElement) {
		this.swiper = new Swiper(element, {
			cssMode: false,
			preloadImages: true,
			lazy: true,
			speed: 500,
			autoplay: typeof this.options.autoplay == 'number' ? { delay: this.options.autoplay } : this.options.autoplay,
			slidesPerView: this.options.slidesPerView,
			centeredSlides: this.options.centeredSlides,
			roundLengths: true,
			watchOverflow: true,
			loop: this.options.loop,
			breakpoints: this.options.breakpoints,
			direction: this.options.vertical ? 'vertical' : 'horizontal',
			slideNextClass: this.options.scale ? 'swiper-slide-next c-swiper--scale' : 'swiper-slide-next',
			slidePrevClass: this.options.scale ? 'swiper-slide-prev c-swiper--scale' : 'swiper-slide-prev',
			watchSlidesProgress: true,
			spaceBetween: this.options.spacing,
			initialSlide: this.options.initialSlide,
			slideToClickedSlide: false,
			keyboard: this.options.keyboard,
			simulateTouch: true,
			preventClicks: this.options.preventClicks,
			parallax: true,
			init: true,
			on: this.options.events,
			pagination: this.options.pagination,
			mousewheel: this.options.mousewheel ? {
				releaseOnEdges: true,
				eventsTarget: this.options.mousewheelTarget
			} : this.options.mousewheel,
			navigation: {
				nextEl: typeof this.options.navigation.nextEl === "string" ? element.querySelector<HTMLElement>(this.options.navigation.nextEl) : null,
				prevEl: typeof this.options.navigation.prevEl === "string" ? element.querySelector<HTMLElement>(this.options.navigation.prevEl) : null,
			},
			scrollbar: {
				el: '.swiper-scrollbar',
			},
		});
	}

	public slideTo(i: number) {
		this.swiper.slideTo(i);
	}
}
